import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp, Target, Zap } from 'lucide-react';
import { mockData } from '../mockData';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Animated Pulsing Circles on Right */}
      <div className="absolute top-1/2 right-0 transform -translate-y-1/2 w-[600px] h-[600px] pointer-events-none">
        {/* Large outer circle */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-primary/5 animate-pulse-slow"></div>
        
        {/* Medium circle */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] rounded-full bg-primary/10 animate-pulse-medium"></div>
        
        {/* Inner circle */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] rounded-full bg-primary/20 animate-pulse-fast"></div>
        
        {/* Core circle with glow */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[100px] h-[100px] rounded-full bg-primary/30 shadow-[0_0_50px_rgba(59,130,246,0.3)] animate-glow"></div>
        
        {/* Floating dots */}
        <div className="absolute top-[20%] left-[30%] w-3 h-3 rounded-full bg-primary/40 animate-float"></div>
        <div className="absolute top-[70%] left-[20%] w-2 h-2 rounded-full bg-primary/30 animate-float-delayed"></div>
        <div className="absolute top-[40%] left-[60%] w-4 h-4 rounded-full bg-primary/25 animate-float-slow"></div>
      </div>

      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full mb-6">
            <Zap className="w-4 h-4 text-primary mr-2" />
            <span className="text-sm font-medium text-primary">
              {mockData.hero.badge}
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            {mockData.hero.title}
            <span className="block mt-2">
              <span className="text-primary">{mockData.hero.titleHighlight}</span>
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-600 mb-8 max-w-2xl leading-relaxed">
            {mockData.hero.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-primary hover:bg-primary/90 text-white text-lg px-8 py-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Beratung anfragen
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="text-lg px-8 py-6 rounded-lg border-2 border-gray-300 hover:border-primary hover:text-primary transition-all duration-200"
            >
              Mehr erfahren
            </Button>
          </div>

          {/* Stats/Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl">
            {mockData.hero.features.map((feature, idx) => {
              const icons = [TrendingUp, Target, Zap];
              const Icon = icons[idx];
              return (
                <div key={idx} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                    <Icon className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">{feature.title}</p>
                    <p className="text-sm text-gray-600">{feature.subtitle}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;